import  React from 'react';

import { SelectionModal } from './selection_modal.jsx';

export default class DropdownMenu extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      menuOpen: false
    }
  }

  toggleOpen(){
    this.setState({
      menuOpen: !this.state.menuOpen
    });
  }

  onSelectionChange(key){
    this.toggleOpen();
    this.props.onSelectionChange(key);
  }

  render() {

    var className = "dropdown-menu" +
      (this.props.isLanguageSelection
        ? "-language"
        : "");

    return(
      <div className={className}>
        <button
          className={"dropbtn " + (this.state.menuOpen ? "menu-open" : "") }
          onClick={(event) => this.toggleOpen()}
        >
          <span>
            {this.props.options[this.props.currentSelection]}
          </span>
          <div className='icon'/>
        </button>
        <SelectionModal
          title={this.props.title}
          items={this.props.options}
          onItemSelected={(item) => this.onSelectionChange(item)}
          onClose={() => this.toggleOpen()}
          visible={this.state.menuOpen}
          value={this.props.currentSelection}
        />
      </div>
    );
  }
}
